export const DEX_LP_COLLAPSED_WIDGET_TYPE_ID = 'DexLpCollapsedWidget';
